"use strict";

/* eslint-disable */
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var seperator = '\\.';
var blacklistedDomainChars = "\\s\\?\\#\\/\\(\\)\\=\\:\\;\\@\\\\\"" + seperator;
var protocol = '(?:(?:https?:)?\\/\\/)';
var www = "(?:www" + seperator + ")";
var domain = www + "?(?:(?:[^" + blacklistedDomainChars + "]+)" + seperator + ")+(?:[^" + blacklistedDomainChars + "]+)";
var path = '(?:(?:\\/[^\\s\\/\\#\\&\\?]*)+\\/?)';
var wildcardPath = '(?:(/(?:[%a-zA-Z0-9_-])*?)*(?:/[\\*]))';
var fileName = '(?:[%a-zA-Z0-9_-]+)';
var fileExtension = '(?:(?:\\.[%a-zA-Z0-9-]+)[^\\.\\s])';
var file = "" + fileName + fileExtension;
var invalidSearchChars = '\\s\\?\\#\\&';
var search = "(?:([\\?&#][^" + invalidSearchChars + "]*?=?([^" + invalidSearchChars + "]*))+)";
var ungroupedSearch = "(?:(?:[\\?&#][^" + invalidSearchChars + "]*?=?(?:[^" + invalidSearchChars + "]*))+)";
var _default = {
  www: www,
  domain: domain,
  protocol: protocol,
  path: path,
  wildcardPath: wildcardPath,
  file: file,
  fileName: fileName,
  fileExtension: fileExtension,
  search: search,
  ungroupedSearch: ungroupedSearch
};
exports.default = _default;
module.exports = exports.default;